
import React from "react";
import { useTranslation } from "react-i18next";
import { AttendeeRow } from "./AttendeeRow";

interface AttendeesListProps {
  attendees: any[];
  classId: string;
  classDate: string;
  updatingAttendanceId: string | null;
  removingClientId: string | null;
  onMarkAttendance?: (bookingId: string, attended: boolean, userName: string) => Promise<boolean>;
  onRemoveClient?: (classId: string, userId: string, date: string, userName: string) => Promise<boolean>;
}

export const AttendeesList: React.FC<AttendeesListProps> = ({
  attendees,
  classId,
  classDate,
  updatingAttendanceId,
  removingClientId,
  onMarkAttendance,
  onRemoveClient
}) => {
  const { t } = useTranslation("common");
  
  if (!attendees || attendees.length === 0) {
    return <div className="text-sm text-muted-foreground">{t("noClients")}</div>;
  }

  return (
    <div className="space-y-2">
      {attendees.map((attendee) => (
        <AttendeeRow 
          key={attendee.id} 
          attendee={attendee}
          classId={classId}
          classDate={classDate}
          isUpdating={updatingAttendanceId === attendee.id}
          isRemoving={removingClientId === attendee.userId}
          onAttendanceChange={(attended) => {
            if (onMarkAttendance) {
              const fullName = `${attendee.userFirstName} ${attendee.userLastName}`;
              return onMarkAttendance(attendee.id, attended, fullName);
            }
            return Promise.resolve(false);
          }}
          onRemove={() => {
            if (onRemoveClient) {
              const fullName = `${attendee.userFirstName} ${attendee.userLastName}`;
              return onRemoveClient(classId, attendee.userId, classDate, fullName);
            }
            return Promise.resolve(false);
          }}
        />
      ))}
    </div>
  );
};
